import React, { useState } from 'react';
import Appearance from 'styles/Appearance.js';

const Button = ({ label, onClick, style, type = 'primary', icon, disabled, loading }) => {

    const [hover, setHover] = useState(false);

    const getButtonStyle = () => {
        switch(type) {
            case 'secondary':
                return Appearance.styles.button.secondary();
            case 'outline':
                return Appearance.styles.button.outline();
            case 'primary':
            default:
                return Appearance.styles.button.primary();
        }
    };

    const getHoverTransform = () => {
        if(disabled || loading) {
            return {};
        }
        if(hover) {
            return {
                transform: 'translateY(-2px)',
                boxShadow: type === 'primary' ? Appearance.boxShadow.button : Appearance.boxShadow.cardHover,
            };
        }
        return {};
    };

    return (
        <button
            onClick={disabled || loading ? null : onClick}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={{
                ...getButtonStyle(),
                ...getHoverTransform(),
                opacity: disabled ? 0.5 : 1,
                cursor: disabled || loading ? 'not-allowed' : 'pointer',
                ...style
            }}>
            {loading && (
                <i 
                    className={'fas fa-spinner fa-spin'} 
                    style={{ marginRight: 8, fontSize: 14 }} />
            )}
            {icon && !loading && (
                <i 
                    className={icon} 
                    style={{ fontSize: 14 }} />
            )}
            {label}
        </button>
    );
};

export default Button;
